/*
Only the latest load of a block may draw it. pageInit runs again after PJAX and on a return
from the back/forward cache; an older request that answers later (or fails later) must not
overwrite what the newer one drew.
*/
const latest = new WeakMap();

/**
 * Marks a new load of `root` as the latest one.
 * @param {Element} root the block being loaded
 * @returns {() => boolean} true while no newer load of the same block has started
 */
export default function startRequest(root) {
    const token = {};
    latest.set(root, token);
    return () => latest.get(root) === token;
}
